<template>
  <q-dialog v-model="openSync" @hide="$emit('hide')">
    <q-card style="width: 50rem; max-width: 80vw; max-height: 85vh">
      <RFQDetail :id="id" show-customer :response-id="responseId" @back="openSync = false" />
    </q-card>
  </q-dialog>
</template>

<script>
import RFQDetail from '../Shared/RFQDetail.vue';

export default {
  components: {
    RFQDetail,
  },
  props: {
    open: {
      required: true,
      type: Boolean,
    },
    id: {
      required: true,
      type: String,
    },
    responseId: {
      required: false,
      type: String,
      default: null,
    },
  },

  computed: {
    openSync: {
      get() {
        return this.open;
      },
      set(value) {
        this.$emit('update:open', value);
      },
    },
  },
};
</script>
